import moment from 'moment'
import api from '@/services/api'
import { getSearchString } from '@/lib/api'

export const getUsers = async (params) => {
    try {
        const resp = await api.post('people/users', {
            ...params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getTargetsCount = async (fields, users, periods) => {
    try {
        const resp = await api.post('people/goals-count', {
            fields,
            users,
            periods,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getTargetsWeight = async (fields, users, periods) => {
    try {
        const resp = await api.post('people/goals-weight', {
            fields,
            users,
            periods,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getTargetsPerformances = async (fields, users, periods) => {
    try {
        const resp = await api.post('people/performances', {
            fields,
            users,
            periods,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getTargetsEvaluations = async (fields, users, periods) => {
    try {
        const resp = await api.post('people/goals-evaluations', {
            fields,
            users,
            periods,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getUsersCurrentStage = async (fields, users) => {
    try {
        const resp = await api.post('people/users-current-stage', {
            fields,
            users,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getUsersReleasedNetworks = async (fields, users) => {
    try {
        const resp = await api.post('people/released-networks', {
            fields,
            users,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getNextStageInfo = async (fields, users) => {
    try {
        const resp = await api.post('people/ready-next-stage', {
            fields,
            users,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getCommittees = async () => {
    try {
        const resp = await api.get('people/committees')
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getStagesFromApi = async () => {
    const today = moment().format('YYYY-MM-DD')
    try {
        const resp = await api.get('/periods/all/events', {
            params: {
                sortedBy: 'asc',
                orderBy: 'start_date',
                search: `period.start_date:${today};period.end_date:${today};event_type:stage_definition`,
                and: 'yes',
            },
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}

export const updateUsersNetwork = async (users) => {
    return await api.post('users/update-users-network', { users })
}

export const getDownloadPeopleFromApi = async (filtered, periodIds = [], userIds = []) => {
    const params = {
        periodIds,
        userIds,
    }

    const searchString = getSearchString(filtered)

    if (searchString) {
        params.search = searchString
        params.and = 'yes'
    }

    try {
        return await api.get('users/download/people', {
            params,
            responseType: 'arraybuffer',
        })
    } catch (e) {
        console.log(e)
    }
}

export const getFilters = async () => {
    try {
        const response = await api.get('/filters')
        return response.data.data
    } catch (e) {
        console.error(e)
    }
}

export const createFilter = async (data) => {
    try {
        const response = await api.post('/filters', data)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getFilterFromApi = async (id) => {
    try {
        const resp = await api.get('/filters/' + id, {
            params: {
                append: 'sections',
            },
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}

export const editFilter = async (data, id) => {
    try {
        const response = await api.put('/filters/' + id, data)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteFilter = async (id) => {
    try {
        const response = await api.delete('filters/' + id)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
